import { EventDispatcher } from "@/events/EventDispatcher";
import SSEEvent, {type EventTypeMap} from "@/events/SSEEvent";
import ApiHelper from "./ApiHelper";
import Config from "./Config";

/**
* Created : 29/02/2024
*/
export default class SSEHelper extends EventDispatcher {

	private static _instance:SSEHelper;
	private _sse!:EventSource;
	private _failCount = 0;
	private _expectedPingInterval = 110*1000;
	private _pingFailTimeout:number = -1;
	private _reconnectDelay = 0;
	private _isMainApp = false;

	constructor() {
		super();
		window.addEventListener("beforeunload", ()=>{
			if(this._sse && this._sse.readyState == this._sse.OPEN) this._sse.close();
		});
	}

	/********************
	* GETTER / SETTERS *
	********************/
	static get instance():SSEHelper {
		if(!SSEHelper._instance) {
			SSEHelper._instance = new SSEHelper();
		}
		return SSEHelper._instance;
	}



	/******************
	* PUBLIC METHODS *
	******************/
	public initialize(isMainApp:boolean):void {
		if(this._sse) return;
		this._isMainApp = isMainApp;
		this.connect();
	}

	override addEventListener<T extends keyof EventTypeMap>(event:T, listenerFunc:(e:SSEEvent<T>)=>void):void {
		super.addEventListener(event, listenerFunc);
	}



	/*******************
	* PRIVATE METHODS *
	*******************/
	/**
	 * Open SSE pipe
	 */
	private connect():void {
		console.log("[SSE] Connecting...");
		if(this._sse) {
			this._sse.onmessage = null;
			this._sse.onopen = null;
			this._sse.onerror = null;
			this._sse.close();
		}

		this._sse = new EventSource(Config.instance.API_PATH+"/sse/register?token=Bearer "+ApiHelper.accessToken+(this._isMainApp ? "&mainApp=true" : ""));
		this._sse.onmessage = (event) => this.onMessage(event);
		this._sse.onopen = (_event) => {
			this._failCount = 0;
			console.log("[SSE] ✅ Connected");
			//randomize event so not everyone potentially spams server after rebooting it
			window.setTimeout(() => {
				this.dispatchEvent(new SSEEvent(SSEEvent.ON_CONNECT));
			}, Math.random()*5000);
		}
		this._sse.onerror = (_event) => {
			console.log("[SSE] ❌ Connection closed...");
			this._sse.close();
			// console.log("ERROR");
			// console.log(event);
			if(++this._failCount === 5) {
				this.dispatchEvent(new SSEEvent(SSEEvent.FAILED_CONNECT));
			}
			const delay = this._reconnectDelay || Math.random()*5000;
			console.log("[SSE] ⌛ Reconnect in " + delay + "ms");
			window.setTimeout(() => {
				this._reconnectDelay = 0;
				this.connect();
			}, delay);
		};

		window.addEventListener("beforeunload", ()=>{
			this._sse.onmessage = null;
			this._sse.onopen = null;
			this._sse.onerror = null;
			this._sse.close();
		})
	}

	/**
	 * Called when receiving a message
	 */
	private onMessage(event:MessageEvent<string>):void {
		this._failCount = 0;
		try {
			let json = JSON.parse(event.data) as {code:keyof EventTypeMap, data:any};

			clearTimeout(this._pingFailTimeout);
			this._pingFailTimeout = window.setTimeout(()=>{
				this.connect();
			}, this._expectedPingInterval);

			if(json.code == "AUTHENTICATION_FAILED") {
				//Avoid autoreconnect
				this._sse.close();
			}

			if(json.code == "SERVER_UPDATE") {
				this._reconnectDelay = json.data.delay;
				console.log("Server update received, reconnecting in "+this._reconnectDelay+"ms");
				return;
			}
			this.dispatchEvent(new SSEEvent(json.code, json.data));
		}catch(error) {
			//ignore
		}
	}

}
